import React from "react";
import withStyles from "@material-ui/styles/withStyles";
import { Button } from "@material-ui/core";

import { styles } from "./ConfirmBillingButton.styles";
import { useDispatch } from "react-redux";
import { billingToBill } from "../../../../reservationsSlice";

function ConfirmBillingButton({ classes, loading, reservationCode }) {
  const dispatch = useDispatch();

  const reviseHandler = () => {
    dispatch(billingToBill({ reservationCode }));
  };

  return (
    <div className={classes.root}>
      <Button
        className={classes.button}
        variant="contained"
        color="primary"
        size="small"
        disabled={loading}
        onClick={reviseHandler}
      >
        Confirm Trip Data
      </Button>
    </div>
  );
}

export default withStyles(styles)(ConfirmBillingButton);
